<template>
  <div class="form-group"
      :class="{
        'input-group': hasIcon,
        'input-group-focus': focused
      }">
      <slot name="label">
        <label v-if="label" class="control-label">
          {{ label }}
        </label>
      </slot>
      <slot name="addonLeft">
        <span v-if="addonLeftIcon" class="input-group-prepend">
          <div class="input-group-text">
            <i :class="addonLeftIcon"></i>
          </div>
        </span>
      </slot>
      <slot>
        <input v-if="date"
            :value="dateData"
            type="date"
            v-bind="$attrs"
            v-on="listeners"
            class="form-control"
            aria-describedby="addon-right addon-left">
        <input v-else-if="number"
               :value="value"
               v-bind="$attrs"
               v-on="listeners"
               type="number"
               class="form-control"
               aria-describedby="addon-right addon-left">
        <input v-else
            :type="type"
            :value="value"
            v-bind="$attrs"
            v-on="listeners"
            class="form-control"
            aria-describedby="addon-right addon-left">
      </slot>
      <slot name="addonRight">
        <span v-if="addonRightIcon" class="input-group-append">
          <div class="input-group-text">
            <i :class="addonRightIcon"></i>
          </div>
        </span>
      </slot>
      <slot name="helperText"></slot>
  </div>
</template>
<script>
  export default{
    inheritAttrs: false,
    name: "base-input",
    props:{
      label: String,
      value: [String, Number],
      addonRightIcon: String,
      addonLeftIcon: String,
      date: {
        type: Boolean,
        default: false
      },
      number: {
        type: Boolean,
        default: false
      },
      type: {
        type: String,
        default: ''
      }
    },
    model: {
      prop: 'value',
      event: 'input'
    },
    data(){
      return{
        focused: false,
        dateData: null,
        numbers: ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9', '.'],
        id: null
      }
    },
    computed:{
      hasIcon(){
        const{addonRight, addonLeft} = this.$slots;
        return addonRight !== undefined || addonLeft !== undefined || this.addonRightIcon !== undefined || this.addonLeftIcon !== undefined;
      },
      listeners(){
        return {
          ...this.$listeners,
          keypress: this.onKeypress,
          input: this.onInput,
          blur: this.onBlur,
          focus: this.onFocus
        }
      }
    },
    methods:{
      onInput(evt) {
        if (this.date) {
          if (this.date && evt.target.value) {
            let date = new Date(evt.target.value);
            this.dateData = date.toISOString().slice(0, 10);
            this.$emit('input', date.getTime());
          } else {
            this.dateData = null;
            this.$emit('input', '');
          }
        } else if (this.number) {
          let str = String(evt.target.value);
          let fltCount = 0;
          let rsl = '';
          for (let c of str) {
            if (this.numbers.includes(c)) {
              rsl += c;
            } else if (fltCount === 0) {
              rsl +='.';
              fltCount++;
            }
          }
          if (fltCount === 0) {
            this.$emit('input', Number.parseInt(rsl));
          } else {
            this.$emit('input', Number.parseFloat(rsl));
          }
        } else {
          this.$emit('input', evt.target.value);
        }
      },
      onFocus(){
        this.focused = true;
      },
      onBlur(){
        this.focused = false;
      },
      onKeypress(evt) {
        if (this.number && !this.numbers.includes(evt.key)) {
          evt.preventDefault();
          return false;
        }
        return true;
      },
    },
    mounted() {
      this.id = this._uid;
      if (this.date) {
        if (this.value) {
          this.dateData = new Date(this.value).toISOString().slice(0, 10);
        } else {
         // this.dateData = new Date().toISOString().slice(0, 10);
         // this.$emit('input', new Date().getTime());
        }
      }
    }
  }
</script>
<style>
</style>
